// extracted by mini-css-extract-plugin
export default {"colorBannerText":"#1a1a1a","primaryButton":"styles_primaryButton__f2o2H","buttonContentLoading":"styles_buttonContentLoading__6dWdA","loadingIcon":"styles_loadingIcon__kVNAZ"};